import { rei } from "@/services/api"

class PapelSegurancaLoteService {
  static index (params = null) {
    return rei.get(`papel-seguranca/lote`, { params }).then(res => res.data)
  }
  static show (id) {
    return rei.get(`papel-seguranca/lote/${ id }`).then(res => res.data)
  }

  static store (lote) {
    return rei.post(`papel-seguranca/lote`, lote).then(res => res.data)
  }

  static update (lote_id, lote) {
    return rei.put(`papel-seguranca/lote/${ lote_id }`, lote).then(res => res.data)
  }

  static delete (loteId) {
    return rei.delete(`papel-seguranca/lote/${ loteId }`, { timeout: 0 }).then(res => res.data)
  }

  static listTipos () {
    return rei.get(`papel-seguranca/tipos`).then(res => res.data)
  }

  static cancelarImpressos (loteId) {
    return rei.post(`papel-seguranca/lote/${ loteId }/cancelar-impressos`, { timeout: 0 }).then(res => res.data)
  }
}

export default PapelSegurancaLoteService
